import {createAction, handleActions} from 'redux-actions';
import {Api} from "../../api/api";
import {logout, onForbidden} from '../account/login';
import {fetchSubmitForm, fetchSubmitFormFailed, resetSubmitFormData, fetchSubmitFormSuccess} from './../common/submitForm';
import {hideModal} from "./../common/activeModal";
import _ from 'lodash';

//- Actions
export const fetchGetAliasesFailed = createAction('FETCH_GET_ALIASES_FAILED');
export const fetchGetAliasesSuccess = createAction('FETCH_GET_ALIASES_SUCCESS');
export const fetchGetAliases = createAction(
    'FETCH_GET_ALIASES',
    () => Api.getAliases(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAliasesSuccess,
        onFail: fetchGetAliasesFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetDefaultAliasFailed = createAction('FETCH_GET_DEFAULT_ALIAS_FAILED');
export const fetchGetDefaultAliasSuccess = createAction('FETCH_GET_DEFAULT_ALIAS_SUCCESS');
export const fetchGetDefaultAlias = createAction(
    'FETCH_GET_DEFAULT_ALIAS',
    () => Api.getDefaultAlias(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetDefaultAliasSuccess,
        onFail: fetchGetDefaultAliasFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onChangeAliasSuccess = () => (dispatch) => {
    dispatch(resetSubmitFormData());
    dispatch(hideModal());
    dispatch(fetchGetAliases());
};

export const onUpdateDefaultAliasSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetDefaultAlias());
};

export const fetchUpdateDefaultAlias = (id, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateDefaultAlias(id, data));
};
export const onUpdateDefaultAlias = createAction(
    'FETCH_UPDATE_DEFAULT_ALIAS',
    (id, data) => Api.updateAlias(id, data),
    () => ({
        apiCall: true,
        onSuccess: onUpdateDefaultAliasSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchUpdateAlias = (id, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateAlias(id, data));
};
export const onUpdateAlias = createAction(
    'FETCH_UPDATE_ALIAS',
    (id, data) => Api.updateAlias(id, data),
    () => ({
        apiCall: true,
        onSuccess: onChangeAliasSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchAddAlias = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onAddAlias(data));
};
export const onAddAlias = createAction(
    'FETCH_ADD_ALIAS',
    (data) => Api.addAlias(data),
    () => ({
        apiCall: true,
        onSuccess: onChangeAliasSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchRemoveAlias = (id) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRemoveAlias(id));
};
export const onRemoveAlias = createAction(
    'FETCH_REMOVE_ALIAS',
    (id) => Api.removeAlias(id),
    () => ({
        apiCall: true,
        onSuccess: onChangeAliasSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchSetDefaultAlias = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onSetDefaultAlias(data));
};
export const onSetDefaultAlias = createAction(
    'FETCH_SET_DEFAULT_ALIAS',
    (data) => Api.setDefaultAlias(data),
    () => ({
        apiCall: true,
        onSuccess: onChangeAliasSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const clearDefaultAlias = createAction('CLEAR_DEFAULT_ALIAS');

//- State
const initialState = {
    fetching: false,
    data: null,
    defaultAliasData: null,
    error: null
};

//- Reducers
export default handleActions({
    FETCH_GET_ALIASES: (state) => {
        return {...state, data: null, error: null, fetching: true};
    },
    FETCH_GET_ALIASES_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_ALIASES_SUCCESS: (state, action) => {
        return {...state, data: action.payload, error: null, fetching: false};
    },
    FETCH_GET_DEFAULT_ALIAS: (state) => {
        return {...state, error: null, fetching: true};
    },
    FETCH_GET_DEFAULT_ALIAS_FAILED: (state, action) => {
        return {...state, defaultAliasData: null, error: action.payload, fetching: false};
    },
    FETCH_GET_DEFAULT_ALIAS_SUCCESS: (state, action) => {
        return {...state, defaultAliasData: action.payload, error: null, fetching: false};
    },
    CLEAR_DEFAULT_ALIAS: (state) => {
        return {...state, defaultAliasData: null};
    }
}, initialState);

//- Selectors
export const getAliases = state => state.aliases;

export const loadingAliases = state => getAliases(state).fetching;

export const getAliasesData = state => getAliases(state).data;

export const getDefaultAliasData = state => getAliases(state).defaultAliasData;

export const getAliasDataById = (state, id) => {
    if (_.isNil(getAliasesData(state))) {
        return null;
    }

    return getAliasesData(state).find(elem => {
        return elem.id === id;
    })
};

export const getDefaultAliasName = state => {
    let defaultAlias = getDefaultAliasData(state);
    if (_.isNil(defaultAlias)) {
        return null;
    }

    return {
        firstName: defaultAlias.firstName,
        lastName: defaultAlias.lastName
    };
};



// WEBPACK FOOTER //
// ./src/reducers/account/aliases.js